import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "total"]
  static values = { currency: String }

  connect() {
    this.element.dataset.opportunityAllocationsConnected = "true"
    this.calculate()
  }

  add(event) {
    event.preventDefault()

    const index = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    const content = this.templateTarget.innerHTML.replaceAll("NEW_ALLOCATION_RECORD", index)
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.calculate()
  }

  remove(event) {
    event.preventDefault()

    const row = event.currentTarget.closest("[data-opportunity-allocation-row]")
    if (!row) return

    const destroyInput = row.querySelector("[data-opportunity-allocation-destroy]")
    if (destroyInput) destroyInput.value = "1"

    row.classList.add("d-none")
    this.calculate()
  }

  calculate() {
    const rows = this.element.querySelectorAll("[data-opportunity-allocation-row]")
    const total = Array.from(rows).reduce((sum, row) => {
      if (row.classList.contains("d-none")) return sum

      const destroyInput = row.querySelector("[data-opportunity-allocation-destroy]")
      if (destroyInput?.value === "1") return sum

      const planningtype = row.querySelector("[data-opportunity-allocation-planningtype]")
      if (!planningtype?.value) return sum

      const amount = row.querySelector("[data-opportunity-allocation-amount]")
      return sum + this.numberValue(amount?.value)
    }, 0)

    this.totalTarget.textContent = this.formatCurrency(total)

  }

  formatCurrency(value) {
    const locale = (document.documentElement.lang || "de").replace("_", "-")
    const currency = this.currencyValue || "EUR"

    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency }).format(value)
    } catch (error) {
      return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value)
    }
  }

  numberValue(value) {
    const number = Number.parseFloat(String(value || "").replace(",", "."))
    return Number.isFinite(number) ? number : 0
  }
}
